import React from "react";
import { connect } from "react-redux";
import { Row, Col, Button, Tabs, Tab, Modal } from "react-bootstrap";
import { slideInLeft, slideInRight } from "react-animations";
import Radium, { StyleRoot } from "radium";
import Teams from "../OurTeam/Teams";
import OpenTime from "../OpenTime/OpenTime";
import ContactMain from "../ContactMain/ContactMain";
import AppConfig from "../../config";
import "../MainPage/MainPageStyle.scss";
import { getActiveTeams } from '../../actions/AdminActions';
import "../Pages/Shared.scss";
import { getImageUrl } from '../../helpers/helpers';
import "./OurTeam.scss";

const API_URL = AppConfig.API_URL;

class OurTeam extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      teams: [],
      selected: false
    };
    props.dispatch(getActiveTeams(this.getTeamsData))
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }
  getTeamsData = (teams) => {
    if (teams) {
      this.setState({ teams })
    }
  }

  getText = (text) => {
    const { loadTranslations, currentLanguage } = this.props;
    return loadTranslations(text, currentLanguage);
  };

  getCard = (team) => {
    return <Col lg={3} md={4} sm={6} xs={12}>
      <div className="teams-container teams-tile">
        <div className="team-avatar">
          <img src={getImageUrl(team.image)} alt="Avatar" class="image" />
        </div>
        <div className="text-center margin-top" style={{ minHeight: '60px' }}>
          <h4>{team.name}</h4>
          <h5 style={{ color: '#848484' }}>{team.title}</h5>
        </div>
        <div className="TeamOverlay">
          <div className="text">
            <Button onClick={() => this.setState({ open: true, selected: team })} className="emergency-bttn">Vollständiges Profil anzeigen</Button>
          </div>
        </div>
      </div>
    </Col>
  }

  render() {
    let config = {
      num: [4, 7],
      rps: 0.1,
      radius: [5, 40],
      life: [1.5, 3],
      v: [2, 3],
      tha: [-40, 40],
      alpha: [0.6, 0],
      scale: [.1, 0.4],
      position: "all",
      color: ["random", "#ff0000"],
      cross: "dead",
      // emitter: "follow",
      random: 15
    };

    if (Math.random() > 0.85) {
      config = Object.assign(config, {
        onParticleUpdate: (ctx, particle) => {
          ctx.beginPath();
          ctx.rect(
            particle.p.x,
            particle.p.y,
            particle.radius * 2,
            particle.radius * 2
          );
          ctx.fillStyle = particle.color;
          ctx.fill();
          ctx.closePath();
        }
      });
    }
    window.onscroll = function () { myFunction() };
    function myFunction() {
      if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
        document.getElementById("experience-passion").className = "feature-section section-gap-full experience-wrap active";
      } else {
        document.getElementById("experience-passion").className = "feature-section section-gap-full experience-wrap";
      }
    }
    const styles = {
      slideInLeft: {
        animation: "x 1s",
        animationName: Radium.keyframes(slideInLeft, "slideInLeft"),
      },
      slideInRight: {
        animation: "x 2s",
        animationName: Radium.keyframes(slideInRight, "slideInRight"),
      },
    };
    const Ärzte = this.state.teams.filter(val => val.category === 'Ärzte');
    const MPA = this.state.teams.filter(val => val.category === 'MPA');
    const Physiotherapeutinnen = this.state.teams.filter(val => val.category === 'Physiotherapeutinnen');
    const Ernährungsberaterin = this.state.teams.filter(val => val.category === 'Ernährungsberaterin');
    const { selected } = this.state;
    return (
      <div>
        <section
          className="page-top-banner team-banner section-gap-full relative"
          data-stellar-background-ratio="0.5"
          style={{ padding: '0' }}
        >
          <div className="overlay overlay-bg" />
          <div className="container">
            <Row>
              <Col className="col-lg-12">
                <div>
                  <h1 style={{ marginTop: '0' }}>Unser Team</h1>
                </div>
              </Col>
            </Row>
          </div>
        </section>
        <section
          className="physio-tab section-gap-half relative ourTeam-Wrap section-gap-45"
          id="about-section"
        // style={{ paddingBottom: '0px' }}
        >
          <div className="container">
            <Tabs defaultActiveKey="Ärzte" id="uncontrolled-tab-example">
              <Tab eventKey="Ärzte" title={<h5 className="profile-name">Ärzte</h5>}>
                <section className="team-wrap relative">
                  <Row className="teams-list-wrap">
                    {Ärzte.map((team) => {
                      return this.getCard(team)
                    })}
                  </Row>
                </section>
              </Tab>
              <Tab eventKey="MPA" title={<h5 className="profile-name">MPA</h5>}>
                <section className="team-wrap relative">
                  <Row className="teams-list-wrap">
                    {MPA.map((team) => {
                      return this.getCard(team)
                    })}
                  </Row>
                </section>
              </Tab>
              <Tab eventKey="Physiotherapeutinnen" title={<h5 className="profile-name">Physiotherapeutinnen</h5>}>
                <section className="team-wrap relative">
                  <Row className="teams-list-wrap">
                    {Physiotherapeutinnen.map((team) => {
                      return this.getCard(team)
                    })}
                  </Row>
                </section>
              </Tab>
              <Tab eventKey="Ernährungsberaterin" title={<h5 className="profile-name">Ernährungsberaterin</h5>}>
                <section className="team-wrap relative">
                  <Row className="teams-list-wrap">
                    {Ernährungsberaterin.map((team) => {
                      return this.getCard(team)
                    })}
                  </Row>
                </section>
              </Tab>
              {/* <Tab eventKey="All" title={<h5 className="profile-name">All</h5>}>
                <section className="team-wrap relative">
                  <Row className="teams-list-wrap">
                    {this.state.teams.map((team) => {
                      return this.getCard(team)
                    })}
                  </Row>
                </section>
              </Tab> */}
            </Tabs>
          </div>
        </section>
        <Modal dialogClassName="modal-60w custom-modal team-modal" show={this.state.open} onHide={() => this.setState({ open: false, selected: false })}>
          {selected && <div className="padding">
          <Modal.Header closeButton>
            {/* <Modal.Title id="contained-modal-title-lg" className="text-left full-width">
              {selected.name}
            </Modal.Title> */}
          </Modal.Header>
            <Row>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="teams-container">
                  <div className="team-avatar">
                    <img src={getImageUrl(selected.image)} alt="Avatar" class="image" />
                  </div>
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="text-center">
                    <h1 style={{ textTransform: "uppercase", letterSpacing: "2px" }}>{selected.name}</h1>
                    <h4 style={{ textTransform: "uppercase", letterSpacing: "1px", color: 'rgb(132, 132, 132)' }}>{selected.title}</h4>
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12} className="text-center">
                <div dangerouslySetInnerHTML={{ __html: `<h5>${selected.description}</h5>` }} />
                <hr className="divider-hr" />
              </Col>
              <Col lg={12} md={12} sm={12} xs={12} style={{ fontSize: "1.5rem" }}>
              <div className="text-center margin-vertical">
              {selected.category !== 'MPA' &&  <h4 style={{ textTransform: 'uppercase', paddingBottom: '2px', borderBottom: '1px dashed #ededed', display: 'inline-block'}}>Ausbildung</h4>}
						  </div>
              <ul className="education-details">
                {selected && selected.trainings.map(val => {
                  return <React.Fragment>
                  <li>
                    <h4 style={{ color: "#848484" }}>{val.period}</h4>
                    <h5>{val.message}</h5>
                  </li>
                  </React.Fragment>
                  // <Row>
                  //   <Col lg={4} md={4} sm={4} xs={12}>
                  //     <div style={{ padding: '5px 0' }}>{val.period}</div>
                  //   </Col>
                  //   <Col lg={8} md={8} sm={8} xs={12}>
                  //     <div style={{ padding: '5px 0' }}>{val.message}</div>
                  //   </Col>
                  // </Row>
                })}
                </ul>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
              <Modal.Footer>
              <Button onClick={() => this.setState({ open: false }, () => this.setState({ selected: false }))} className="emergency-bttn">Schliessen</Button>
              </Modal.Footer>
                {/* <center><Button onClick={() => this.setState({ open: false }, () => this.setState({ selected: false }))} className="emergency-bttn">CLOSE</Button></center> */}
              </Col>
            </Row>
          </div>}
        </Modal>
        {/* <OpenTime />
        <ContactMain /> */}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentLanguage: state.users.currentLanguage,
  };
}

export default connect(mapStateToProps)(OurTeam);



// WEBPACK FOOTER //
// ./screens/OurTeam/OurTeam.js